export function getRadianAngle(degreeValue: number): number {
  return (degreeValue * Math.PI) / 180;
}
